import googlePartners from '../media/GooglePartners.png';
import mercaLogo from '../media/mercaLogo.png';
import microsoft from '../media/microsoft.png';
import meta from '../media/meta.jpg';
import godaddy from '../media/godaddy.png';
import googleGmp from '../media/GoogleGMP.png';
import ssl from '../media/ssl.png';
import metaMarketing from '../media/metaMarketing.png';
import ovalBig from '../media/OvalBig.png';
import oval from '../media/Oval.png';

const partners = [
  { id: 'google', logo: googlePartners, name: 'Google Partners' },
  { id: 'merca', logo: mercaLogo, name: 'Merca 2.0' },
  { id: 'microsoft', logo: microsoft, name: 'Microsoft' },
  { id: 'meta', logo: meta, name: 'Meta' },
  { id: 'godaddy', logo: godaddy, name: 'GoDaddy' },
];

const certifications = [
  { id: 'gmp', logo: googleGmp, name: 'Google Marketing Platform', modifier: '' },
  { id: 'ssl', logo: ssl, name: 'Certificado SSL', modifier: '' },
  {
    id: 'meta-marketing',
    logo: metaMarketing,
    name: 'Meta Certified Digital Marketing Associate',
    modifier: 'partnersCertificationMeta',
  },
];

/**
 * Logos de partners y certificaciones del home.
 *
 * Los tres óvalos del final son decoración de fondo posicionada por CSS; van
 * con alt vacío para que los lectores de pantalla los ignoren.
 */
const Partners = () => (
  <div className="partners">
    <article className="partnersArticle">
      <h4 className="partnersTitle">Partners</h4>
      <div className="partnersLogos">
        {partners.map(({ id, logo, name }) => (
          <div className="partnersLogo" key={id}>
            <img src={logo} alt={name} />
          </div>
        ))}
      </div>
    </article>

    <article className="partnersArticle">
      <h4 className="partnersTitle">Certificaciones</h4>
      <div className="partnersCertifications">
        {certifications.map(({ id, logo, name, modifier }) => (
          <div className={`partnersCertification ${modifier}`.trim()} key={id}>
            <img src={logo} alt={name} />
          </div>
        ))}
      </div>
    </article>

    <div className="partnersOvalBig">
      <img src={ovalBig} alt="" />
    </div>
    <div className="partnersOvalMedium">
      <img src={oval} alt="" />
    </div>
    <div className="partnersOval">
      <img src={oval} alt="" />
    </div>
  </div>
);

export default Partners;
